import {integration} from '../integration';
import { store } from '../stores/mainStore';

export class BonusGame{
	constructor(mng, diceHand) { 
		this.m = mng; 
		this.diceHand = diceHand;
		this.chestHome = {x: this.m.config.width/2, y: 0.85* this.m.config.height}
		this.chestOutY = 1.1 * this.m.config.height;
		this.diceOutY = -0.5* this.m.config.height;
	}
	create(bkgImage, frameImage) {
		this.ui = this.m.ui;
		this.diceHome = this.diceHand.dice.map((_d, i) => this.diceHand.getDiceHomePosition(i))
		this.bkg = bkgImage.setVisible(false);
		this.frame = frameImage.setVisible(false);
		this.chest = this.m.scene.add.image(this.chestHome.x, this.chestOutY, 'chest')
			.setDepth(5)
	}
	show(par) {
		this.bkg.setVisible(par)
		this.frame.setVisible(par)
	}

	anticipation  = diceIndices => {
		const fillIndex = ind => {
			const {filled, winPlaces} = store.curPattern
			if(!filled.includes(ind))
				filled.push(ind)
			if(!winPlaces.includes(ind))
				winPlaces.push(ind)
			store.curPattern = {...store.curPattern, filled, winPlaces}			
		}
		const diceData = diceIndices.map((ind, i) => { 
			const fromRect = this.diceHand.dice[ind].diceImage.getBounds();
			const toRect = document.getElementById('pbdot_'+ind).getBoundingClientRect()

			return {
				value: this.diceHand.dice[ind].getFrameNumber(),
				xFrom: fromRect.x, yFrom: fromRect.y,
				xTo: toRect.x, yTo: toRect.y,
				onDiceEnd: () => {
					window.manager.playAudio('pitch_'+i)
					fillIndex(ind)
				}
			}
		})
		const check4oak = () => {
			if(diceIndices.length === store.curPattern.pattern.length - 1
				&& store.activeMatch.currentHand.handName === 'four-of-a-kind'
			) {
				const lastInd = store.curPattern.pattern.find(v => !diceIndices.includes(v))
				const fromRect = this.ui.winBannerBack.getBounds();
				const toRect = document.getElementById('pbdot_'+ lastInd).getBoundingClientRect()

				const flyWild = () => {
					store.diceFlyAnimConfig = { 
						diceData: [{ value: 9, // Wild dice
							xFrom: fromRect.centerX, yFrom: fromRect.centerY,
							xTo: toRect.x, yTo: toRect.y,
							onDiceEnd: () => {
								window.manager.playAudio('pitch_4')
								fillIndex(lastInd)
							}
						}],
						diceSize: this.diceHand.diceActualWidth/2,
						onComplete: endAnticipation
					}					
				}
				this.m.scene.tweens.add({
					targets: this.ui.winBannerBack,
					ease: 'Linear', duration: 250,
					scale: '*=' + 1.2, yoyo: true, 
					onYoyo: flyWild
				});				
				this.m.scene.tweens.add({
					targets: this.ui.winBanner,
					ease: 'Linear', duration: 250,
					scale: '*=' + 1.2, yoyo: true,
					x: '-=' + 40, y: '+=' + 10,		// adjust for centering
				});
			} else endAnticipation();
		}
		const endAnticipation = () => {
			setTimeout(() => this.m.gameState = 'prebonus', 500)
		}
		store.diceFlyAnimConfig = { diceData,
			diceSize: this.diceHand.diceActualWidth,
			onComplete: () => {
				setTimeout(check4oak, 300)
			}
		}
	}

	startBonus = () => {
		this.show(true);
		this.startBonusRound();
	}
	startBonusRound = () => {
		console.log('4565 start bonus round :: data =', store.activeMatch.bonusData.rounds[0])
		store.curBonusRound = store.activeMatch.bonusData.rounds.shift();
		if(store.custom.usePopper) {
			window.manager.playAudio('Transition_subtleWhoosh_v2a')
			this.ui.popper.startRound();
			this.ui.popper.btnEnable(true);
		}
	}
	dealDice = () => {
		console.log('4565 start dice dealing')
		integration.postMixPanelEvent('bonus_roll_'+ (store.curBonusRound.roundId+1))
		this.moveChest(true);
		this.ui.startRolling();
	}
	rollResult = () => {
		const hasRolls = store.curBonusRound.rolls.length > 0;
		console.log('4565 roll result :: has =', hasRolls);
		if (!hasRolls) {
			console.log('4565 \t no more rolls')
			this.endBonusRoll()
			//setTimeout(this.endBonusRound, 300)
		} else {
			console.log('4565 \t roll win :: roll =', store.curBonusRound.rolls[0]);
			this.curRoll = store.curBonusRound.rolls.shift();
			console.log('4565   roll result :: roll =', this.curRoll, 
				'blow =', this.curRoll.blown.map(v => v),
				'move =', this.curRoll.moved.map(v => v.face + '=' + v.from + '-' + v.to),
				'app =', this.curRoll.appear.map(v => v.to + '='+ v.face),
				'num =', this.curRoll.rollId, 'rou =', store.curBonusRound.roundId
			);

			const flow = this.m.scene.tweens.timeline({
				onComplete: this.diceFall,
				onStart: () => {
					this.curRoll.blown.forEach(ind => {
						this.diceHand.dice[ind].addFlair('flair')
					})
				}
			}).add(this.ui.showWinBanner(this.curRoll.handName))
		
			const startBlowTime = 750, blowTime = 500,  alphaTime = 250, staggerTime = 50, flyTime = 500
			const startFlyTime = startBlowTime + blowTime + staggerTime * (this.curRoll.blown.length - 1);
			this.curRoll.blown.forEach((ind, i) => {
				const d = this.diceHand.dice[ind]
				const home = this.diceHome[ind]
				const coin = this.m.scene.add.image(home.x, home.y, 'coin')
					.setDepth(10).setScale(0.5).setAlpha(0)

				flow.add({targets: d.diceImage, 
					offset: startBlowTime + staggerTime*i,
					duration: blowTime, ease: 'easeOut',
					alpha: 0,	scale: '*=2',
					onStart: () => {
						if(i === 0)				this.m.playAudio('twinkle')
						d.removeFlair();
						d.addExplosion();
					},
				})
				.add({targets: coin, alpha: 1, 
					duration: alphaTime, offset: '-=' + alphaTime,
				})
				.add({
					targets: coin,
					x: this.chestHome.x + 0.07*this.m.config.width, y: this.chestHome.y, 
					duration: flyTime, ease: 'easeOut',
					offset: startFlyTime + staggerTime*i,
					onStart: () => { 
						if(i === 0)	{
							this.m.playAudio('chipAdd')
							this.ui.makePulsate(this.chest, flyTime/2, 1.25, false);
						}
					},
					onComplete: () => coin.destroy()
				})
			})
			flow.play();
		}
	}
	diceFall = () => {
		this.ui.clearWinBanner();
		console.log('4565 diceFall :: num =', this.curRoll.rollId, 'rou =', store.curBonusRound.roundId)
		if(this.curRoll.rollId === 5) {		// max hands received - no more dice motion
			console.log('4565 \t ---> move to end of round as max hands, blown =', this.curRoll.blown)
			this.m.scene.tweens.add({
				...this.ui.showWinBanner('bonus_max_hand'),
				onComplete: this.endBonusRound,
			})
		} else if(this.curRoll.moved.length > 0) {
			const dices = this.diceHand.dice
			this.m.scene.tweens.timeline({
				tweens: this.curRoll.moved.map(({from, to, face}, i) => {return {
					onStart: () => console.log('4565 \t\t move from', from, 'to =', to, 'face =', face),
					targets: dices[from].diceSprite,
					y: this.diceHome[to].y,
					duration: 250, ease: 'Linear', offset: 50*i,
					onComplete: () => [dices[from], dices[to]] = [dices[to], dices[from]]
				}}),
				onComplete: this.diceAdd
			})
		} else this.diceAdd();
	}
	diceAdd = () => {
		console.log('4565 diceAdd :: num =', this.curRoll.rollId, 'rou =', store.curBonusRound.roundId)
		this.m.scene.tweens.timeline({
			tweens: this.curRoll.appear.map(({to, face}, i) => {
				const dice = this.diceHand.dice[to]
				return {
					onStart: () => {
						console.log('4565 \t\t  appear to =', to, 'face =', face)
						if(i === 0)				
							this.m.playAudio('SFX_Gameplay_DiceRoll')
						dice.diceImage.setTexture('dice2D_sheet', face)
							.setAlpha(1).setScale(this.diceHand.diceBigScale);
						dice.diceSprite.setY(this.diceOutY + this.diceHome[to].y)
					},
					targets: dice.diceSprite,
					y: this.diceHome[to].y, ease: 'easeIn',
					duration: 250,	offset: 50*i
				}
			}),
			onComplete: this.endBonusRoll			
		})
	}
	endBonusRoll = () => {
		console.log('4565 endBonusRoll :: num =', this.curRoll?.rollId, 'rou =', store.curBonusRound.roundId)
		console.log('4565 check next roll l =', store.curBonusRound.rolls.length, 'final =', this.diceHand.dice.map(d => d.diceNum))
		if(store.curBonusRound.rolls.length > 0)
			this.rollResult()
		else {
			this.m.scene.tweens.add({
				...this.ui.showWinBanner('bonus_no_hands'),
					//this.curRoll?.rollId === 5 ? 'bonus_max_hand' : 'bonus_no_hands'),
				onComplete: this.endBonusRound,
			})
		}
	}
	endBonusRound = () => {
		console.log('4565 end bonus round :: more =', store.activeMatch.bonusData.rounds.length)
		integration.postMixPanelEvent(store.curBonusRound.payout > 0 ? 'bonus_win' : 'bonus_lost');
		integration.postMixPanelEvent('bonus_tumbles_' + (
			this.curRoll ? this.curRoll.rollId+1 : 1
		))
		this.curRoll = null;
		store.curBonusRound = null;
		const flow = this.m.scene.tweens.timeline({
			onComplete: () => {
				if(store.activeMatch.bonusData.rounds.length > 0)
					this.startBonusRound()
				else
					this.endBonus()
			}
		}).add({
			...this.moveChest(false, true),
			onComplete: () => this.ui.clearWinBanner(),
			completeDelay: 300
		})
		this.diceHand.dice.forEach((d, i) => {
			flow.add({
				onStart: () => {
					d.diceNum = i;
					d.diceImage.setAlpha(1).setScale(this.diceHand.diceBigScale);
				},
				targets: d.diceSprite, scale: 0, 
				offset: '-=' + 1.6*100,		//20*i, 
				duration: 100, yoyo: true,
				onYoyo: () => {
					if(store.custom.usePopper)
						d.diceImage.setTexture('logo_dice_sheet', i)
				}
			})
		})
		flow.play()
	}
	endBonus = () => {
		this.show(false);
		this.m.gameState = 'endBonus'
	}

	moveChest = (moveUp, inTimeline = false) => {
		const up = {from: this.chestOutY, to:  this.chestHome.y}
		const down = {from: this.chestHome.y, to: this.chestOutY}
		const tween = {targets: this.chest,
			y: moveUp ? up : down,
			duration: 500, 
			onStart: () => {if(!moveUp) this.m.playAudio('Transitions_Movement')}
		}
		if(inTimeline) 	return tween
		else this.m.scene.tweens.add(tween)
	}
}